import LimitedTokensActionTypes from './limitedTokens-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    error: null,
    sellLimitedTokensFee: null,
    buyLimitedTokensFee: null,
    limitedTokenDetails: null,
    availableLimitedTokens: null,
    tokenHotWalletFee: null,
    redeemedTokensPayload: null,
}

const limitedTokenReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LimitedTokensActionTypes.START_FETCH_AVAILABLE_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, FETCH_AVAILABLE_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_FETCH_AVAILABLE_LIMITED_TOKENS: {
            return {
                ...state,
                availableLimitedTokens: action.payload,
                loader: { ...state.loader, FETCH_AVAILABLE_LIMITED_TOKENS: null },
                success: { ...state.success, FETCH_AVAILABLE_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_FETCH_AVAILABLE_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, FETCH_AVAILABLE_LIMITED_TOKENS: null },
                success: { ...state.success, FETCH_AVAILABLE_LIMITED_TOKENS: null },
                error: { ...state.error, FETCH_AVAILABLE_LIMITED_TOKENS: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_FETCH_AVAILABLE_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, FETCH_AVAILABLE_LIMITED_TOKENS: null },
                success: { ...state.success, FETCH_AVAILABLE_LIMITED_TOKENS: null },
                error: { ...state.error, FETCH_AVAILABLE_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.START_BUY_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, BUY_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_BUY_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, BUY_LIMITED_TOKENS: null },
                success: { ...state.success, BUY_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_BUY_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, BUY_LIMITED_TOKENS: null },
                success: { ...state.success, BUY_LIMITED_TOKENS: null },
                error: { ...state.error, BUY_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FAILURE_BUY_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, BUY_LIMITED_TOKENS: null },
                success: { ...state.success, BUY_LIMITED_TOKENS: null },
                error: { ...state.error, BUY_LIMITED_TOKENS: true },
            }
        }

        case LimitedTokensActionTypes.START_TRANSFER_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_TRANSFER_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_LIMITED_TOKENS: null },
                success: { ...state.success, TRANSFER_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_TRANSFER_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_LIMITED_TOKENS: null },
                success: { ...state.success, TRANSFER_LIMITED_TOKENS: null },
                error: { ...state.error, TRANSFER_LIMITED_TOKENS: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_TRANSFER_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_LIMITED_TOKENS: null },
                success: { ...state.success, TRANSFER_LIMITED_TOKENS: null },
                error: { ...state.error, TRANSFER_LIMITED_TOKENS: true },
            }
        }

        case LimitedTokensActionTypes.START_WITHDRAW_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, WITHDRAW_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_WITHDRAW_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, WITHDRAW_LIMITED_TOKENS: null },
                success: { ...state.success, WITHDRAW_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_WITHDRAW_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, WITHDRAW_LIMITED_TOKENS: null },
                success: { ...state.success, WITHDRAW_LIMITED_TOKENS: null },
                error: { ...state.error, WITHDRAW_LIMITED_TOKENS: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_WITHDRAW_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, WITHDRAW_LIMITED_TOKENS: null },
                success: { ...state.success, WITHDRAW_LIMITED_TOKENS: null },
                error: { ...state.error, WITHDRAW_LIMITED_TOKENS: true },
            }
        }

        case LimitedTokensActionTypes.START_SELL_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, SELL_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_SELL_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, SELL_LIMITED_TOKENS: null },
                success: { ...state.success, SELL_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_SELL_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, SELL_LIMITED_TOKENS: null },
                success: { ...state.success, SELL_LIMITED_TOKENS: null },
                error: { ...state.error, SELL_LIMITED_TOKENS: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_SELL_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, SELL_LIMITED_TOKENS: null },
                success: { ...state.success, SELL_LIMITED_TOKENS: null },
                error: { ...state.error, SELL_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.START_GET_SELL_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                loader: { ...state.loader, GET_SELL_LIMITED_TOKENS_FEE: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_GET_SELL_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                sellLimitedTokensFee: action.payload,
                loader: { ...state.loader, GET_SELL_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_SELL_LIMITED_TOKENS_FEE: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_GET_SELL_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                sellLimitedTokensFee: null,
                loader: { ...state.loader, GET_SELL_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_SELL_LIMITED_TOKENS_FEE: null },
                error: { ...state.error, GET_SELL_LIMITED_TOKENS_FEE: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_GET_SELL_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                sellLimitedTokensFee: null,
                loader: { ...state.loader, GET_SELL_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_SELL_LIMITED_TOKENS_FEE: null },
                error: { ...state.error, GET_SELL_LIMITED_TOKENS_FEE: true },
            }
        }

        case LimitedTokensActionTypes.START_GET_BUY_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                loader: { ...state.loader, GET_BUY_LIMITED_TOKENS_FEE: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_GET_BUY_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                buyLimitedTokensFee: action.payload,
                loader: { ...state.loader, GET_BUY_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_BUY_LIMITED_TOKENS_FEE: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_GET_BUY_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                buyLimitedTokensFee: null,
                loader: { ...state.loader, GET_BUY_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_BUY_LIMITED_TOKENS_FEE: null },
                error: { ...state.error, GET_BUY_LIMITED_TOKENS_FEE: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_GET_BUY_LIMITED_TOKENS_FEE: {
            return {
                ...state,
                buyLimitedTokensFee: null,
                loader: { ...state.loader, GET_BUY_LIMITED_TOKENS_FEE: null },
                success: { ...state.success, GET_BUY_LIMITED_TOKENS_FEE: null },
                error: { ...state.error, GET_BUY_LIMITED_TOKENS_FEE: true },
            }
        }

        case LimitedTokensActionTypes.START_GET_LIMITED_TOKEN_DETAILS: {
            return {
                ...state,
                loader: { ...state.loader, GET_LIMITED_TOKEN_DETAILS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_GET_LIMITED_TOKEN_DETAILS: {
            return {
                ...state,
                limitedTokenDetails: action.payload,
                loader: { ...state.loader, GET_LIMITED_TOKEN_DETAILS: null },
                success: { ...state.success, GET_LIMITED_TOKEN_DETAILS: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_GET_LIMITED_TOKEN_DETAILS: {
            return {
                ...state,
                limitedTokenDetails: null,
                loader: { ...state.loader, GET_LIMITED_TOKEN_DETAILS: null },
                success: { ...state.success, GET_LIMITED_TOKEN_DETAILS: null },
                error: { ...state.error, GET_LIMITED_TOKEN_DETAILS: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_GET_LIMITED_TOKEN_DETAILS: {
            return {
                ...state,
                limitedTokenDetails: null,
                loader: { ...state.loader, GET_LIMITED_TOKEN_DETAILS: null },
                success: { ...state.success, GET_LIMITED_TOKEN_DETAILS: null },
                error: { ...state.error, GET_LIMITED_TOKEN_DETAILS: true },
            }
        }

        case LimitedTokensActionTypes.START_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: {
            return {
                ...state,
                loader: { ...state.loader, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: {
            return {
                ...state,
                tokenHotWalletFee: action.payload,
                loader: { ...state.loader, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
                success: { ...state.success, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: true },
            }
        }
        case LimitedTokensActionTypes.FINISH_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: {
            return {
                ...state,
                tokenHotWalletFee: null,
                loader: { ...state.loader, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
                success: { ...state.success, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
                error: { ...state.error, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
            }
        }
        case LimitedTokensActionTypes.FAILURE_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: {
            return {
                ...state,
                tokenHotWalletFee: null,
                loader: { ...state.loader, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
                success: { ...state.success, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: null },
                error: { ...state.error, FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: true },
            }
        }

        case LimitedTokensActionTypes.START_REDEEM_LIMITED_TOKENS: {
            return {
                ...state,
                loader: { ...state.loader, REDEEM_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.SUCCESS_REDEEM_LIMITED_TOKENS: {
            return {
                ...state,
                redeemedTokensPayload: action.payload,
                loader: { ...state.loader, REDEEM_LIMITED_TOKENS: null },
                success: { ...state.success, REDEEM_LIMITED_TOKENS: true },
            }
        }
        case LimitedTokensActionTypes.FAILURE_REDEEM_LIMITED_TOKENS: {
            return {
                ...state,
                redeemedTokensPayload: null,
                error: { ...state.error, REDEEM_LIMITED_TOKENS: true },
                loader: { ...state.loader, REDEEM_LIMITED_TOKENS: null },
                success: { ...state.success, REDEEM_LIMITED_TOKENS: null },
            }
        }
        case LimitedTokensActionTypes.FINISH_REDEEM_LIMITED_TOKENS: {
            return {
                ...state,
                redeemedTokensPayload: null,
                error: { ...state.error, REDEEM_LIMITED_TOKENS: null },
                loader: { ...state.loader, REDEEM_LIMITED_TOKENS: null },
                success: { ...state.success, REDEEM_LIMITED_TOKENS: null },
            }
        }

        default:
            return state
    }
}

export default limitedTokenReducer
